import { Link } from "react-router-dom";
import { Truck } from "lucide-react";
import { useShippingConfig, euro, freeOver } from "@/lib/shipping";

export const shippingLine = (c) => {
  const it = freeOver(c, "italy");
  const eu = freeOver(c, "eu");
  return `Italia ${euro(c.italy_fee)}${it ? `, gratis sopra ${euro(it)}` : ""} · Europa ${euro(c.eu_fee)}${eu ? `, gratis sopra ${euro(eu)}` : ""}`;
};

export const ShippingSummary = ({ className = "", testid = "shipping-summary" }) => {
  const c = useShippingConfig();
  return (
    <p className={`flex flex-wrap items-center gap-x-1.5 gap-y-0.5 text-xs text-stone-600 ${className}`} data-testid={testid}>
      <Truck className="h-3.5 w-3.5 shrink-0 text-amber-600" /><span>{shippingLine(c)}</span>
      <Link to="/spedizioni" className="whitespace-nowrap font-semibold text-amber-700 underline" data-testid={`${testid}-link`}>Spedizioni e resi</Link>
    </p>
  );
};
